'use client';

import { useEffect } from 'react';
import ErrorMessage from '@/components/ui/ErrorMessage';

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorMessage reset={reset} />;
}
